module.exports = __webpack_public_path__ + "img/4.56735b02.jpg";